"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var redux_1 = require("redux");
var core_1 = require("@material-ui/core");
var translate_1 = __importDefault(require("../../../app/localization/translate"));
var store_1 = require("../../../app/store");
var ProgramStore_1 = require("../../../app/store/ProgramStore");
var urls_1 = __importDefault(require("../../../app/urls"));
var useStyles = (0, styles_1.makeStyles)(function (theme) { return (0, styles_1.createStyles)({
    navActions: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: theme.spacing(8, 0),
        '@media print': {
            display: 'none',
        },
    },
    appActions: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: theme.spacing(4, 0),
        '@media print': {
            display: 'none',
        },
    },
    navButton: {
        margin: theme.spacing(0, 6),
    },
    navIconLeft: {
        marginRight: theme.spacing(1),
    },
    navIconRight: {
        marginLeft: theme.spacing(1),
    },
}); });
var TaskNavigation = function (_a) {
    var task = _a.task;
    var classes = useStyles();
    var dispatch = (0, store_1.useYouwellDispatch)();
    var translate = (0, translate_1.default)();
    var redirect = (0, redux_1.bindActionCreators)(ProgramStore_1.actionCreators, dispatch).redirect;
    var elementIndex = task.elementIndex, currentTaskNr = task.currentTaskNr, programId = task.programId;
    var isLastTask = currentTaskNr === task.listLength - 1;
    var isFirstTask = currentTaskNr === 0;
    var clickNext = function (nextDirection) {
        var nextTaskNr = currentTaskNr + nextDirection;
        var redirectUrl = '';
        if (isLastTask && nextDirection > 0) {
            redirectUrl = "".concat(urls_1.default.outsideProgram.program, "/").concat(programId);
        }
        else if (isFirstTask && nextDirection < 0) {
            redirectUrl = "".concat(urls_1.default.outsideProgram.program, "/").concat(programId);
        }
        else {
            redirectUrl = "".concat(urls_1.default.outsideProgram.task, "/").concat(programId, "/").concat(elementIndex, "/").concat(nextTaskNr);
        }
        redirect(redirectUrl);
    };
    return (react_1.default.createElement("div", { className: classes.navActions },
        react_1.default.createElement(core_1.Button, { variant: "outlined", color: "secondary", onClick: function () { return clickNext(-1); } }, translate(isFirstTask ? 'cancel' : 'task.goBack')),
        react_1.default.createElement(core_1.Button, { color: "secondary", variant: "contained", onClick: function () { return clickNext(1); } }, translate(isLastTask ? 'task.completeTask' : 'task.goForward'))));
};
exports.default = TaskNavigation;
